import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { ComparisonTables } from './components/ComparisonTables';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingToast } from './components/FloatingToast';
export function App() {
  return <div className="min-h-screen bg-[#0a1628] text-white selection:bg-[#d4a843] selection:text-[#0a1628]" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductBreakdown data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />
      <ComparisonTables data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
      <FloatingToast data-id="element-10" />
    </div>;
}